import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./empenhoForm";
import Select from "../common/form/select";
import { adicionarReticencias } from "../utils/adicionarReticencias";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { setModoTela, initForm, salvar, excluir, setFiltro, getLista, getListaCliente, getListaUnidadeConsumidora } from "./empenhoActions";
import { Loading } from "../common/loading/loading";

function Empenho(props) {
    useEffect(() => {
        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista(props.filtro.id_cliente, props.filtro.ano_referencia);
    }, [props.filtro]);

    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente || props.usuarioLogado.usuario_implantacao) {
        return <div />;
    }

    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela == "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                {props.modoTela == "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela == "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela == "lista" ? lista() : null}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/empenho.js (incluir) e no endpoint POST /api/empenho
                                disabled={!props.usuarioLogado.acesso_empenho_adicionar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({});
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter((cli) => cli.cliente_prefeitura)}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                });
                            }}
                        />
                    </Row>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Cliente</Th>
                                <Th sticky>Nº do Empenho</Th>
                                <Th sticky>Ano de Referência</Th>
                                <Th sticky>Valor Previsto</Th>
                                <Th sticky>Unidades Pertencentes</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                const itemForm = {
                                    ...item,
                                    valor_previsto: String(item.valor_previsto).replace(".", ","),
                                    unidades_consumidoras: item.unidades_consumidoras.map((uc) => ({ label: uc.nome, value: uc.id })),
                                };
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_empenho_visualizar,
                                                event: () => {
                                                    props.setModoTela("visualizacao", itemForm);
                                                    props.initForm(itemForm);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/empenho.js (editar) e no endpoint PUT /api/empenho
                                                disabled: !props.usuarioLogado.acesso_empenho_editar,
                                                event: () => {
                                                    props.setModoTela("cadastro", itemForm);
                                                    props.initForm(itemForm);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/empenho.js (excluir) e no endpoint DELETE /api/empenho
                                                disabled: !props.usuarioLogado.acesso_empenho_excluir,
                                                event: () => {
                                                    props.setModoTela("exclusao", itemForm);
                                                    props.initForm(itemForm);
                                                },
                                            },
                                        ]}
                                    >
                                        <Td maxWidth={200}>{item.nome_cliente}</Td>
                                        <Td>{item.numero}</Td>
                                        <Td>{item.ano_referencia}</Td>
                                        <Td>{"R$ " + adicionarPontosMilhar(String(item.valor_previsto).replace(".", ","))}</Td>
                                        <Td maxWidth={200}>
                                            <ul>
                                                {item.unidades_consumidoras.map((uc) => (
                                                    <li>{adicionarReticencias(uc.numero + " - " + uc.nome, 50)}</li>
                                                ))}
                                            </ul>
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.empenho.modoTela,
    formularioValues: getFormValues("empenhoForm")(state),
    aguardando: state.empenho.aguardando,
    filtro: state.empenho.filtro,
    lista: state.empenho.lista,
    listaCliente: state.empenho.listaCliente,
    listaUnidadeConsumidora: state.empenho.listaUnidadeConsumidora,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Empenho);
